if (!customElements.get("wish-list-button")) {
    class WishListButton extends HTMLElement {
        constructor() {
            super();
            this.meta = meta;
            this.state = {
                opacityAdded: "1",
                opacityRemoved: "0.4",
                isAdded: false,
            };

            this.setupEventForButton();
        }

        /**
         * @returns {string[]}
         */
        static get observedAttributes() {
            return ["product-id", "product-variant-id"];
        }

        // noinspection JSUnusedGlobalSymbols
        connectedCallback() {
            if (!this.rendered) {
                this.init();
            }
        }

        // noinspection JSUnusedGlobalSymbols
        attributeChangedCallback() {
            this.init();
        }

        setupData() {
            this.data = {
                productId: parseInt(this.getAttribute("product-id")),
                variantId: parseInt(this.getAttribute("product-variant-id")),
                isWishlist: this.getAttribute("is-wishlist") || false,
            };
        }

        init() {
            this.setupData();
            
            var isPageWishList = (this.data.isWishlist === 'true');
            if (this.meta.page.pageType !== "product" && this.meta.page.pageType !== "collection" && !isPageWishList) {
                this.classList.add("card-favorite--none");
            }

            this.themeLoaded((swat) => {
                this.swat = swat;
                this.swatData = SwymProductVariants[this.data.variantId];

                if (!this.swatData) {
                    this.swatData = {
                        empi: this.data.productId,
                        epi: this.data.variantId,
                    };
                }

                this.render();
            });

            this.rendered = true;
        }

        /**
         * @param addedCallBack
         * @param removedCallBack
         */
        wishListLoader(addedCallBack, removedCallBack) {
            this.swat.fetch((list) => {
                let isInWishList = list.find((item) => {
                    return item.empi === this.data.productId && item.epi === this.data.variantId;
                });

                if (isInWishList) {
                    addedCallBack();
                } else {
                    removedCallBack();
                }
            });
        }

        /**
         * @param callback
         */
        themeLoaded(callback) {
            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }

            window.SwymCallbacks.push((swat) => {
                callback(swat);
            });
        }

        render() {
            this.wishListLoader(
                () => {
                    this.setWishListAdded();
                },
                () => {
                    this.setWishListRemoved();
                }
            );
        }

        setupEventForButton() {
            this.addEventListener("click", () => {
                if (this.state.isAdded) {
                    this.swat.removeFromWishList(this.swatData, () => {
                        this.setWishListRemoved();
                        this.newEventForUpdateStatus();
                    });
                } else {
                    this.swat.addToWishList(this.swatData, () => {
                        this.setWishListAdded();
                        this.showNotificationAdded();
                        this.newEventForUpdateStatus();
                    });
                }

                this.reCheck();
            });

            // Apply only product detail
            this.setupEventForProductDetail();
        }

        setupEventForProductDetail() {          
            if (this.meta.page.resourceType === "product") {
                // console.log(document.querySelector('[name="id"]'));
                document.querySelector('[name="id"]').addEventListener("change", (e) => {
                    let variantId = e.target.value;
                    this.setAttribute("product-variant-id", variantId);

                    if (variantId == "") {
                        this.classList.add("disable");
                        return true;
                    } else {
                        this.classList.remove("disable");
                    }

                    if (this.meta.product && this.meta.product.variants) {
                        let variantSelected = this.meta.product.variants.find((variant) => {
                            return parseInt(variantId) === variant.id;
                        });

                        const notification = this.querySelector("wish-list-notification");
                        notification.hide();
                    }
                });
            }
        }

        /**
         * Re-check all wishListButton
         * In case there is more than 1 button on the same page, the state will be synchronized.
         */
        reCheck() {
            let wishListOther = document.querySelectorAll(`[product-variant-id="${this.data.variantId}"]`);
            if (wishListOther) {
                wishListOther.forEach((button) => {
                    if (button !== this) {
                        setTimeout(() => {
                            button.setAttribute("product-variant-id", this.data.variantId.toString());
                        }, 2000);
                    }
                });
            }
        }

        showNotificationAdded() {
            const notification = this.querySelector("wish-list-notification");
            if (notification) {
                notification.show();
            }
        }

        setWishListAdded() {
            this.state.isAdded = true;
            this.classList.add("card-favorite--on");
            this.classList.remove("card-favorite--off");
        }

        setWishListRemoved() {
            this.state.isAdded = false;
            this.classList.remove("card-favorite--on");
            this.classList.add("card-favorite--off");
        }

        newEventForUpdateStatus() {
            this.dispatchEvent(new CustomEvent("changeStatus", { bubbles: true }));
        }
    }

    customElements.define("wish-list-button", WishListButton);
}
